var _path, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFlowClaimLinkTemplates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H76C78.2091 0 80 1.79086 80 4V76C80 78.2091 78.2091 80 76 80H4C1.79086 80 0 78.2091 0 76V4Z",
    fill: "#5F11EA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7102_1886",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 20,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7102_1886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4447 55C23.6947 55 23.0441 54.7246 22.493 54.1737C21.9422 53.6226 21.6667 52.9721 21.6667 52.2221V48.1113C21.6667 47.3613 21.9422 46.7107 22.493 46.1596C23.0441 45.6088 23.6947 45.3333 24.4447 45.3333H35.3334C36.0834 45.3333 36.7338 45.6088 37.2847 46.1596C37.8358 46.7107 38.1113 47.3613 38.1113 48.1113V52.2221C38.1113 52.9721 37.8358 53.6226 37.2847 54.1737C36.7338 54.7246 36.0834 55 35.3334 55H24.4447ZM44.778 55C44.028 55 43.3774 54.7246 42.8263 54.1737C42.2755 53.6226 42.0001 52.9721 42.0001 52.2221V27.7779C42.0001 27.0279 42.2755 26.3774 42.8263 25.8263C43.3774 25.2754 44.028 25 44.778 25H55.5555C56.3055 25 56.9561 25.2754 57.5072 25.8263C58.058 26.3774 58.3334 27.0279 58.3334 27.7779V52.2221C58.3334 52.9721 58.058 53.6226 57.5072 54.1737C56.9561 54.7246 56.3055 55 55.5555 55H44.778ZM24.4447 52.2221H35.3334V48.1113H24.4447V52.2221ZM44.778 52.2221H55.5555V27.7779H44.778V52.2221ZM50.1717 50C50.5665 50 50.8958 49.8635 51.1597 49.5904C51.4236 49.3171 51.5555 48.986 51.5555 48.5971C51.5555 48.2082 51.422 47.8818 51.1551 47.6179C50.8879 47.354 50.5567 47.2221 50.1617 47.2221C49.767 47.2221 49.4377 47.3553 49.1738 47.6217C48.9099 47.8878 48.778 48.2176 48.778 48.6113C48.778 48.9907 48.9115 49.3171 49.1784 49.5904C49.4456 49.8635 49.7767 50 50.1717 50ZM24.4447 41.4446C23.6947 41.4446 23.0441 41.169 22.493 40.6179C21.9422 40.0671 21.6667 39.4167 21.6667 38.6667V27.7779C21.6667 27.0279 21.9422 26.3774 22.493 25.8263C23.0441 25.2754 23.6947 25 24.4447 25H35.3334C36.0834 25 36.7338 25.2754 37.2847 25.8263C37.8358 26.3774 38.1113 27.0279 38.1113 27.7779V38.6667C38.1113 39.4167 37.8358 40.0671 37.2847 40.6179C36.7338 41.169 36.0834 41.4446 35.3334 41.4446H24.4447ZM31.7363 32.7779C32.1252 32.7779 32.4516 32.6447 32.7155 32.3783C32.9794 32.1122 33.1113 31.7824 33.1113 31.3888C33.1113 31.0093 32.9781 30.6829 32.7117 30.4096C32.4456 30.1365 32.1158 30 31.7222 30C31.3427 30 31.0163 30.1365 30.743 30.4096C30.4699 30.6829 30.3334 31.014 30.3334 31.4029C30.3334 31.7918 30.4699 32.1182 30.743 32.3821C31.0163 32.646 31.3474 32.7779 31.7363 32.7779ZM24.4447 38.2638L27.8613 33.6946L31.6388 38.7221H35.3334V27.7779H24.4447V38.2638Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlowClaimLinkTemplates);
export default __webpack_public_path__ + "static/media/icon-flow-claim-link-templates.372d6cc94b40497ff6cfbcdce94d5a6f.svg";
export { ForwardRef as ReactComponent };